import { Component, OnInit, ElementRef, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { GfichierService } from '../../service/gfichier.service';
import { LocationStrategy } from '@angular/common';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {

  @Input() content: string;

  @Output() eventchild = new EventEmitter<string>();

  devoir = true;

  isChecked = false;//false;
  mdp: string = "";
  password: string = "";
  password1: string = "";
  email: string = "";
  nom: string = "";
  prenom: string = "";
  btconnecte: string = "Se connecter";
  affichage = 0;
  message = "";
  

  visicreer = false;
  visimeconnecter = false;
  visimdp = true;
  titre = "Se coonecter";


  constructor(public gfichier: GfichierService,
    
    //bloquer le retour
    private location: LocationStrategy,
  ) {
    // preventing back button in browser implemented by "Samba Siva"  
    history.pushState(null, null, window.location.href);
    this.location.onPopState(() => {
      history.pushState(null, null, window.location.href);
    });
  }

  ngOnChanges() {
    //alert(this.content);
    this.eventchild.emit("hidebtprecedent");
    this.eventchild.emit("hidebtvalider");
    //this.debuguer();
    if(this.content=="devoir") this.devoir = true;

  }

  ngOnInit() {}

  debuguer() {
    /*
    this.mdp = "GdWr7";
    this.password = "12345678";
    this.password = "test";
    
    this.password1 = "12345678";
    this.email = "rgauthier.p@gmail.com";
    this.nom = "GAUTHIER";
    this.prenom = "Richard";
    this.isChecked = true;
    this.seconnecter();
    */
 }

  
  seconnecter() {

    //  let email : string = this.idmail.nativeElement.value;
    //  let mdp : string = this.idmdp.nativeElement.value;
    //alert(this.isChecked);
    let data1 = [];
       
  if( this.affichage == 0 ) {
    if (this.mdp == "" || this.email == "" || this.password == "" ) alert("les champs sont obligatoires");
    else if ( this.validateEmail(this.email)) alert("Email non valide!");
    else if (!this.isChecked) alert("Vous devez accepter les conditions d'utilisations.")
    else {
        //alert("aaa");
       data1[0]={
           mdp : this.mdp,
           email : this.email,
           password : this.password,
           devoir : this.devoir,
           connexion : 0

       };
        this.envoyer(data1,"connexion");
     }

  } else if( this.affichage == 1 ) {
    if (this.password == "" || this.password1 == "" || this.mdp == "" || this.email == ""  || this.nom == "" || this.prenom == "" ) alert("les champs sont obligatoires");
    else if ( this.validateEmail(this.email)) alert("Email non valide!");
    else if (this.password !=  this.password1 ) alert("Les mots de passe sont différent.");
    else if (!this.isChecked) alert("Vous devez accepter les conditions d'utilisations.")
    else {
       data1[0]={
           mdp : this.mdp,
           email : this.email,
           nom : this.nom,
           prenom : this.prenom,
           password : this.password,
           connexion : 1
       };
       this.envoyer(data1,"newuser");
     }

  } else if( this.affichage == 2 ) {
    if ( this.email == "" ) alert("les champs sont obligatoires");
    else if ( this.validateEmail(this.email)) alert("Email non valide!");
    else if (!this.isChecked) alert("Vous devez accepter les conditions d'utilisations.")
    else {
       data1[0]={
           email : this.email,
           connexion : 2
       };
       this.envoyer(data1,"modifiermdp");
     }

    }  
  }//

  envoyer(data , phppage) {
    //alert(this.password);
    this.gfichier.seconnecter3(data,phppage).then(
      successData => {
          //alert(successData);
          let data = String(successData);
          //alert(data);
          if(data=="existe") {
            this.message = "Le compte existe déjà et son adresse email n'a pas été validé!";
            this.btconnecte = "Se connecter";
            this.affichage=0;
            this.visicreer = false;
          } else if(data=="verifier") {
            this.message = "Le compte existe déjà!";
            this.btconnecte = "Se connecter";
            this.affichage=0;
            this.visicreer = false;
          } else if(data=="send") {
            this.message = "Un email vous a été envoyé pour modifier votre mot de passe.";
            this.btconnecte = "Se connecter";
            this.affichage=0;
            this.visimdp = true;
            this.visicreer = false;
          } else if(data=="enregistrer") {
            this.message = "Le compte a été enregistré. Maintenant, vous devez vous rendre dans votre boite email pour le valider.";
            this.affichage=0  ;
            this.btconnecte = "Se connecter";
            this.visicreer = false;
          } else if(data=="prof") {
            this.message = "Le code professeur n'est pas correct!";
            this.btconnecte = "Se connecter";
            this.affichage=0  ;
            this.visicreer = false;
          } else if(data=="login") {
            alert("Problème d'email ou de mot de passe!");
            this.btconnecte = "Se connecter";
            this.affichage=0  ;
            this.visicreer = false;
          } else if(data=="connecter") {
            this.message = "Vous êtes connecté!";
            this.affichage=0  ;
            this.btconnecte = "Se connecter";
            this.visicreer = false;
            this.eventchild.emit("changerpage");
          } else if(data=="tricher") {
            this.message = "Vous avez déjà fait ce devoir!";
          } else if(data=="erreur") {
            alert("Problème de connexion avec le serveur!");
            //this.visicreer = false;
          }
          


      },
      rejectData => {
        console.log(rejectData);
      }
    );
    
  }//fin envoyer


  mdpoublier() {
    this.affichage=2;
    this.btconnecte = "Modifier mon mot de passe";
    this.message = "";
    this.visimdp = false;
    this.visimeconnecter = true;
    
  }

  meconnecter() {
    this.visimeconnecter = false;
    this.visimdp = true;
  }

  creercompte() {
    this.visicreer=true;
    this.titre = "Se créer un compte";
    this.btconnecte = "Créer le compte";
    this.affichage=1;
    this.message = "";
    
  }

 validateEmail(email) {
  return !(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email));
 }


}
